/**
 * Component: VideoModal
 * Fullscreen modal that displays an embedded video in a responsive aspect box.
 * Blocks the page behind a dark backdrop and provides a close button.
 *
 * Props:
 * - isOpen: boolean
 * - onClose: () => void
 * - title?: string (defaults to "Demo Video")
 * - videoUrl?: string (iframe src; defaults to a sample YouTube URL)
 */
import React from 'react';
import { X } from 'lucide-react';

export function VideoModal({ 
  isOpen, 
  onClose, 
  title = "Demo Video", 
  videoUrl = "https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1" 
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80">
      <div className="relative w-full max-w-5xl bg-white dark:bg-gray-900 rounded-lg shadow-xl overflow-hidden">
        <div className="flex justify-between items-center p-4 border-b dark:border-gray-800">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>
          <button 
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          >
            <X className="h-6 w-6 text-gray-500 dark:text-gray-400" />
          </button>
        </div>
        <div className="aspect-video w-full">
          <iframe
            className="w-full h-full"
            src={videoUrl}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
} 